import template from './back.template.html';
import controller from './back.controller';
import './back.scss';

export default {
  template,
  controller,
};



// WEBPACK FOOTER //
// ./src/app/shared/back/back.component.js